import React, { createContext, useContext, useMemo, useState, FC, ReactNode } from 'react';

interface HeaderThemeContextValue {
  isDarkMode: boolean;
  setIsDarkMode: (value: boolean) => void;
}

const HeaderThemeContext = createContext<HeaderThemeContextValue>({
  isDarkMode: false,
  setIsDarkMode: () => {},
});

interface Props {
  children: ReactNode;
}

// Lets page content deep inside <Main> (e.g. TopHeroSection) drive the Header's
// theme, since Header is a sibling of that content rather than an ancestor.
export const HeaderThemeProvider: FC<Props> = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const value = useMemo(() => ({ isDarkMode, setIsDarkMode }), [isDarkMode]);
  return <HeaderThemeContext.Provider value={value}>{children}</HeaderThemeContext.Provider>;
};

export const useHeaderTheme = () => useContext(HeaderThemeContext);
